// extracted by mini-css-extract-plugin
export default {"sliderContainer":"PriceSlider_sliderContainer__UTM2y","sliderMark":"PriceSlider_sliderMark__lA6HA"};